module.exports = __webpack_public_path__ + "static/media/BR 3.b97e380c.mp3";